import angular from 'angular';
import moment from 'moment';

import * as actions from '../../../store/actions';

const mapStateToProps = (state) => ({
  userInfo: state.user.loyaltyStatistics,
});

angular
  .module('myConsultApp')
  .controller('applyUserActivityController', ($ngRedux, $scope, $rootScope, $http, ENV) => {
    $scope.initData = () => {
      $scope.activity = {
        activity_type_id: null,
        user_id: $rootScope.userId,
        activity_date: null,
        num_points: null,
        notes: '',
      };
      $scope.activity_type = null;
      $scope.isActivityDateDisabled = false;
      $scope.isNumPointsDisabled = false;
      $scope.isActivityChanged = false;
      $scope.initialActivityDate = null;
      $scope.errors = [];
      $scope.activityDateOutOfRange = false;
      $scope.processing_apply_activity = false;
      $scope.allowNegativePoints = false;
    };

    $scope.close = () => {
      $rootScope.closeComponent();
    };

    const componentVisibleListener = $rootScope.$watch('componentOpened', () => {
      if (!$rootScope.componentOpened) {
        $('#apply-activity-activity-date').val(null);
        if ($scope.applyActivity != undefined) {
          $scope.applyActivity.$setPristine();
          $scope.applyActivity.$setUntouched();
        }
        var e = document.getElementById('activity-user-name_value');
        if (!$rootScope.isUserPage && e != undefined) {
          e.value = '';
          var $e = angular.element(e);
          $e.triggerHandler('input');
        }
      }
    });

    const activityTypeListener = $scope.$watch(
      'activity_type',
      () => {
        if ($scope.activity_type) {
          $scope.errors = [];
          const activity_type = $scope.activity_type;
          $scope.activityDateOutOfRange = false;
          $scope.isActivityDateDisabled = false;
          $scope.isNumPointsDisabled = false;
          var start_date = $scope.activity_type.date_start
            ? moment($scope.activity_type.date_start)
            : null;
          var end_date = $scope.activity_type.date_end
            ? moment($scope.activity_type.date_end)
            : null;
          var today = moment(new Date());
          if (start_date && end_date && (start_date > today || end_date < today)) {
            $scope.activityDateOutOfRange = true;
          } else if (start_date && start_date > today) {
            $scope.activityDateOutOfRange = true;
          } else if (end_date && end_date < today) {
            $scope.activityDateOutOfRange = true;
          }

          if (activity_type.allow_negative_points === true) {
            $scope.allowNegativePoints = true;
          } else {
            $scope.allowNegativePoints = false;
          }
          if (activity_type.num_points && Number(activity_type.num_points) != 0) {
            $scope.isNumPointsDisabled = true;
            $scope.isActivityDateDisabled = true;
            $scope.activity.num_points = activity_type.num_points;
            if ($scope.activityDateOutOfRange) {
              $scope.errors.push('The activity you selected is no longer available.');
            }
          } else if ($scope.activityDateOutOfRange) {
            $scope.isNumPointsDisabled = true;
            $scope.activity.num_points = null;
          } else {
            $scope.isNumPointsDisabled = false;
            $scope.isActivityDateDisabled = false;
            $scope.activity.num_points = null;
          }

          $scope.activity.activity_date = null;
          $scope.initialActivityDate = $scope.initialActivityDate === '' ? null : '';
          $('#apply-activity-activity-date').val(null);
          $scope.isActivityChanged = true;
        }
      },
      true,
    );

    const activityDateListener = $scope.$watch('activity.activity_date', () => {
      if ($scope.activity.activity_date && $scope.activity.activity_date != '') {
        $scope.isNumPointsDisabled = true;
        $scope.activity.num_points = null;
      } else if (
        $scope.activity_type &&
        (!$scope.activity_type.num_points || Number($scope.activity_type.num_points) == 0) &&
        $scope.isActivityChanged === false
      ) {
        $scope.isNumPointsDisabled = false;
      }
      $scope.isActivityChanged = false;
    });

    const activityPointsListener = $scope.$watch('activity.num_points', () => {
      if ($scope.allowNegativePoints && $scope.activity.num_points) {
        $scope.activity.num_points =
          $scope.activity.num_points
            .toString()
            .trim()
            .substring(0, 1)
            .replace(/[^0-9\-]/g, '') +
          $scope.activity.num_points
            .toString()
            .trim()
            .substring(1)
            .replace(/[^0-9]/g, '');
      } else if ($scope.activity.num_points) {
        $scope.activity.num_points = $scope.activity.num_points
          .toString()
          .trim()
          .replace(/[^0-9]/g, '');
      }
      if ($scope.activity.num_points && Number($scope.activity.num_points) != 0) {
        $scope.isActivityDateDisabled = true;
        $('#apply-activity-activity-date').val(null);
        $scope.initialActivityDate = null;
        $scope.activity.activity_date = null;
      } else if ($scope.isActivityChanged === false) {
        $scope.isActivityDateDisabled = false;
        $scope.activity.activity_date = null;
      }
      $scope.isActivityChanged = false;
    });

    $scope.init = () => {
      $scope.unsubscribe = $ngRedux.connect(mapStateToProps, actions)($scope);
    };

    $scope.applyUserActivity = () => {
      $scope.processing_apply_activity = true;
      $scope.errors = [];
      const activity = { ...$scope.activity };

      if ($scope.isNumPointsDisabled === true || activity.num_points === '') {
        activity.num_points = null;
      }
      if ($scope.isActivityDateDisabled === true || activity.activity_date === '') {
        activity.activity_date = null;
      }
      if ($scope.activity_type) {
        activity.activity_type_id = $scope.activity_type.id;
      }
      if (activity.notes === '') {
        activity.notes = null;
      }
      if ($scope.isActivityDateDisabled !== true && activity.activity_date) {
        activity.activity_date = moment(activity.activity_date).format('YYYY-MM-DD HH:mm:ss');
      }
      $scope
        .createUserActivity($http, ENV, {
          'user-activities': activity,
        })
        .then((res) => {
          $scope.$apply(() => {
            $rootScope.refreshLoyaltyStatistics();
            $scope.initData();
            $rootScope.getData();
            $rootScope.closeComponent();
            $scope.processing_apply_activity = false;
          });
        })
        .catch((error) => {
          $scope.processing_apply_activity = false;
          const errors = error.data['user-activities'];
          const result = [];
          for (let [key, value] of Object.entries(errors)) {
            const keyString = key
              .split('_')
              .map((item) => $scope.capitalize(item))
              .join(' ');
            if (Array.isArray(value)) {
              result.push(...value.map((item) => `${keyString}: ${item}`));
            } else {
              result.push(`${keyString}: ${value}`);
            }
          }
          $scope.$apply(() => {
            $scope.errors = result;
          });
        });
    };

    $scope.updateActivityDate = (val) => {
      $scope.activity.activity_date = val;
    };

    $scope.searchClients = (query) => {
      return $scope
        .getUsers($http, ENV, {
          application_subscription: 5,
          is_active: true,
          is_anonymized: false,
          autocomplete: true,
          groups: 2,
          order: 'last_name',
          search: query,
        })
        .then((res) => {
          return res;
        });
    };

    $scope.searchClientsPage = (query) => {
      return $scope.getUsersByUrl($http, query).then((res) => {
        return res;
      });
    };

    $scope.selectActivityUser = (data) => {
      $scope.activity.user_id = data.id;
      $rootScope.userId = data.id;
    };

    $scope.getActivityTypes = () => {
      return $scope
        .getUserActivityTypes($http, ENV, {
          paginate: true,
          status: 'enabled',
          order: 'title',
          manual_trigger_enabled: true,
        })
        .then((res) => {
          return res;
        });
    };

    $scope.getNextActivityTypes = (query) => {
      return $scope.getUserActivityTypesByUrl($http, query).then((res) => {
        return res;
      });
    };

    $scope.selectActivityType = (option) => {
      $scope.activity_type = option;
    };

    $scope.$watch('subComponent', (newValue, oldValue) => {
      if (oldValue === 'apply-activity') {
        $scope.initData();
      }
    });

    $scope.init();
    $scope.initData();
    $scope.$on('$destroy', () => {
      $scope.unsubscribe();
      componentVisibleListener();
      activityTypeListener();
      activityDateListener();
      activityPointsListener();
      $scope.errors = [];
    });
  })
  .directive('applyUserActivity', () => {
    return {
      templateUrl: 'templates/v2/apply-user-activity.html',
    };
  });
